export default __webpack_public_path__ + "static/media/Rerebrace of the Fallen Empire.31f9e9b9.jpg";